import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function UnlockIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M8 10V6C8 3.79395 9.79443 2 12 2C14.2056 2 16 3.79395 16 6V7H18V6C18 2.69141 15.3086 0 12 0C8.69141 0 6 2.69141 6 6V10H3V15C3 19.9629 7.0376 24 12 24C16.9624 24 21 19.9629 21 15V10H8ZM19 15C19 18.8594 15.8599 22 12 22C8.14014 22 5 18.8594 5 15V12H19V15ZM14 18H10V16H14V18Z",
    fill: "currentColor"
  }));
}